import { compressImage, convertToFile } from "../../helpers/utils";

export const setLoading = (isLoading) => ({
  type: "SET_LOADING",
  payload: isLoading,
});

export const setError = (error) => ({
  type: "SET_ERROR",
  payload: error,
});

export const setSuccess = (success) => ({
  type: "SET_SUCCESS",
  payload: success,
});

export const agregarInvitado =
  (info, hashkey, photos, personaid) => async (dispatch) => {
    if (!hashkey) {
      dispatch({
        type: "AGREGAR_INVITADO",
        payload: {
          success: false,
          message: "Link de invitación inválido o expirado",
        },
      });
      return;
    }

    const axios = require("axios");
    const token = localStorage.getItem("tokenControl");

    try {
      // First create the invitado
      const response = await axios({
        method: "post",
        // url: `${process.env.REACT_APP_SERVER_CONTROL}invitado/add`,
        url: `${process.env.REACT_APP_SERVER_CONTROL}invitado/registroxmail`,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        data: JSON.stringify({
          ...info,
          hashkey,
          personaid,
        }),
      });

      // const invitadoId = response.data.id || (response.data.message && response.data.message.split(" ")[1].split(",")[0]);

      const invitadoId = response.data.invitadoId;

      // Upload profile photo if exists
      if (photos.profile) {
        try {
          await axios({
            method: "post",
            url: `${
              process.env.REACT_APP_SERVER_CONTROL
            }file?type=invitado&id=${parseInt(invitadoId)}`,
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + token,
            },
            data: { data: photos.profile },
          });
        } catch (error) {
          console.error(
            "Error uploading profile photo:",
            error.response?.data || error.message
          );
        }
      }

      // Upload DNI photo if exists
      if (photos.dni) {
        try {
          const dniFormData = new FormData();
          dniFormData.append("file", convertToFile(photos.dni));

          await axios({
            method: "post",
            url: `${process.env.REACT_APP_SERVER_CONTROL}invitado-dni/${invitadoId}`,
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${token}`,
            },
            data: dniFormData,
          });
        } catch (error) {
          console.error(
            "Error uploading DNI photo:",
            error.response?.data || error.message
          );
        }
      }

      // Upload license photo if exists
      if (photos.license) {
        try {
          const licenseFormData = new FormData();
          licenseFormData.append("file", convertToFile(photos.license));

          await axios({
            method: "post",
            url: `${process.env.REACT_APP_SERVER_CONTROL}invitado-licencia/${invitadoId}`,
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${token}`,
            },
            data: licenseFormData,
          });
        } catch (error) {
          console.error(
            "Error uploading license photo:",
            error.response?.data || error.message
          );
        }
      }

      dispatch({
        type: "AGREGAR_INVITADO",
        payload: {
          success: true,
          message: "Invitado registrado exitosamente",
        },
      });

      return { data: { id: invitadoId } };
    } catch (error) {
      console.error(
        "Main error in agregarInvitado:",
        error.response?.data || error.message
      );
      dispatch({
        type: "AGREGAR_INVITADO",
        payload: {
          success: false,
          message:
            error.response?.data?.message || "Error al registrar el invitado",
        },
      });
      throw error;
    }
  };

// Helper function to convert base64 to blob
const base64ToBlob = async (base64Data) => {
  const base64WithoutPrefix = base64Data.split(",")[1];
  const byteCharacters = atob(base64WithoutPrefix);
  const byteNumbers = new Array(byteCharacters.length);

  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: "image/jpeg" });
};

export const getTiposDocumento = () => async (dispatch) => {
  var axios = require("axios");
  var token = localStorage.getItem("tokenControl");

  var config = {
    method: "get",
    maxBodyLength: Infinity,
    url: `${process.env.REACT_APP_SERVER_CONTROL}gestionTienda`,
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  axios(config)
    .then(function (response) {
      dispatch({ type: "GET_TIPOS_DOCUMENTO", payload: response.data.data });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getTokenControl = () => async () => {
  var axios = require("axios");

  var data = JSON.stringify({
    user: "develone",
    password: "develonepwd",
  });

  var config = {
    method: "post",
    url: `${process.env.REACT_APP_SERVER_CONTROL}token`,
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      localStorage.setItem("tokenControl", response.data.token);
    })
    .catch(function (error) {
      console.log(error);
    });
};

//f siempre envia 'confirmacion' true (boton confirmar)
export const editarInvitado =
  (info, invitadoId, nrodocumento, photos, invitacionid) =>
  async (dispatch) => {
    const axios = require("axios");
    const token = localStorage.getItem("tokenControl");
    const FormData = require("form-data");
    // console.log("info", info);
    try {
      // First update the invitado info
      await axios({
        method: "put",
        // url: `${process.env.REACT_APP_SERVER_CONTROL}invitado/${invitadoId}`,
        url: `${process.env.REACT_APP_SERVER_CONTROL}invitado/registroxmail/${invitadoId}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        data: {
          ...info,
          invitadoid: parseInt(invitadoId),
          nrodocumento,
          confirmacion: true,
          invitacionid,
        },
      });

      // Only upload profile photo if it's not a blob URL and exists
      if (photos?.profile && !photos.profile.startsWith("blob:")) {
        try {
          await axios({
            method: "post",
            url: `${process.env.REACT_APP_SERVER_CONTROL}file?type=invitado&id=${invitadoId}`,
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            data: { data: photos.profile },
          });
        } catch (error) {
          console.error(
            "Error uploading profile photo:",
            error.response?.data || error.message
          );
        }
      }

      // Only upload DNI photo if it's not a blob URL and exists
      if (photos?.dni && !photos.dni.startsWith("blob:")) {
        try {
          const dniFile = convertToFile(photos.dni, "dni");
          const dniFormData = new FormData();
          dniFormData.append("file", dniFile);

          await axios({
            method: "post",
            url: `${process.env.REACT_APP_SERVER_CONTROL}invitado-dni/${invitadoId}`,
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${token}`,
            },
            data: dniFormData,
          });
        } catch (error) {
          console.error(
            "Error uploading DNI photo:",
            error.response?.data || error.message
          );
        }
      }

      // Only upload license photo if it's not a blob URL and exists
      if (photos?.license && !photos.license.startsWith("blob:")) {
        try {
          const licenseFile = convertToFile(photos.license, "license");
          const licenseFormData = new FormData();
          licenseFormData.append("file", licenseFile);

          await axios({
            method: "post",
            url: `${process.env.REACT_APP_SERVER_CONTROL}invitado-licencia/${invitadoId}`,
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${token}`,
            },
            data: licenseFormData,
          });
        } catch (error) {
          console.error(
            "Error uploading license photo:",
            error.response?.data || error.message
          );
        }
      }

      // Only upload vehicle photo if it's not a blob URL and exists
      if (photos?.vehicle && !photos.vehicle.startsWith("blob:")) {
        try {
          const vehicleFile = convertToFile(photos.vehicle, "vehicle");
          const vehicleFormData = new FormData();
          vehicleFormData.append("file", vehicleFile);

          await axios({
            method: "put",
            url: `${process.env.REACT_APP_SERVER_CONTROL}image-vehiculo/${invitadoId}`,
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${token}`,
            },
            data: vehicleFormData,
          });
        } catch (error) {
          console.error(
            "Error uploading vehicle photo:",
            error.response?.data || error.message
          );
        }
      }

      dispatch({
        type: "EDITAR_INVITADO",
        payload: {
          success: true,
          message: "Invitado actualizado exitosamente",
        },
      });

      return { data: { id: invitadoId } };
    } catch (error) {
      console.error(
        "Error in editarInvitado:",
        error.response?.data || error.message
      );
      dispatch({
        type: "EDITAR_INVITADO",
        payload: {
          success: false,
          message:
            error.response?.data?.message || "Error al actualizar el invitado",
        },
      });
      throw error;
    }
  };
